import type { Fields, Properties } from '~/models'

const PARCEL_DATA_KEY_LABELS: { [key: string]: string } = {
  parcelnumb: 'Parcel ID',
  updated: 'Updated',
  address: 'Address',
  city: 'City',
  county: 'County',
  state2: 'State Abbr',
  szip5: 'Zip Code',
  lat: 'Latitude',
  lon: 'Longitude',
  usecode: 'Land Use Code',
  zoning: 'Zoning',
  zoning_description: 'Zoning Desc',
  legal_description: 'Legal Desc',
  sale_price: 'Sale Price',
  transaction_date: 'Transaction Date',
  year_built: 'Year Built',
  building_sf: 'Building SF',
  acres: 'Acres',
  acres_calculated: 'Acres Calc',
  number_of_buildings: 'Num of Buildings',
  floors: 'Floors',
  land_use_description: 'Land Use Desc',
  fema_flood_zone: 'Flood Zone',
  fema_flood_zone_subtype: 'Flood Zone Subtype',
  lowest_parcel_elevation: 'Elevation',
  market_value_building: 'Market Value Building',
  landval: 'Market Value Land',
  market_value_total: 'Market Value Total',
}

const orderedKeys = Object.keys(PARCEL_DATA_KEY_LABELS)
const ignoredKeys = [
  'fema_flood_zone_raw',
  'original_address',
  'original_mailing_address',
  'path',
]

export function getParcelLabelValues(parcelData: Properties) {
  const matchingKeys: string[] = []
  const nonMatchingKeys: string[] = []

  Object.keys(parcelData.fields).forEach((key) => {
    if (key in PARCEL_DATA_KEY_LABELS) {
      matchingKeys.push(key)
    } else if (!ignoredKeys.includes(key)) {
      nonMatchingKeys.push(key)
    }
  })

  matchingKeys.sort((a, b) => orderedKeys.indexOf(a) - orderedKeys.indexOf(b))
  nonMatchingKeys.sort()

  return matchingKeys.concat(nonMatchingKeys).map((key) => ({
    key,
    label: PARCEL_DATA_KEY_LABELS[key] || key.replaceAll('_', ' '),
    value: parcelData.fields[key as keyof Fields],
  }))
}
